export const selectFeaturesState = state => state.features;
export const selectFeaturesLoaded = state => state.features.loaded;

// Guard rule (Plan 06 §Key contracts): mining defaults visible until proven otherwise (`null`
// before the fetch resolves, or `true` once resolved, both keep mining UI showing); only an
// explicit `false` hides it.
export const selectMiningEnabled = state => state.features.mining !== false;

// Colo surfaces are opt-in: only render once the flag has explicitly resolved to `true`.
export const selectColoEnabled = state => state.features.colo === true;
